var __extends = this && this.__extends || function () {
  var extendStatics = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (d, b) {
    d.__proto__ = b;
  } || function (d, b) {
    for (var p in b) {
      if (b.hasOwnProperty(p)) d[p] = b[p];
    }
  };

  return function (d, b) {
    extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

import { CoreUserApiKeyAuthProviderClient } from "mongodb-stitch-core-sdk";

var UserApiKeyAuthProviderClientImpl = function (_super) {
  __extends(UserApiKeyAuthProviderClientImpl, _super);

  function UserApiKeyAuthProviderClientImpl(requestClient, routes) {
    return _super.call(this, requestClient, routes) || this;
  }

  UserApiKeyAuthProviderClientImpl.prototype.createApiKey = function (name) {
    return _super.prototype.createApiKey.call(this, name);
  };

  UserApiKeyAuthProviderClientImpl.prototype.fetchApiKey = function (keyId) {
    return _super.prototype.fetchApiKey.call(this, keyId);
  };

  UserApiKeyAuthProviderClientImpl.prototype.fetchApiKeys = function () {
    return _super.prototype.fetchApiKeys.call(this);
  };

  UserApiKeyAuthProviderClientImpl.prototype.deleteApiKey = function (keyId) {
    return _super.prototype.deleteApiKey.call(this, keyId);
  };

  UserApiKeyAuthProviderClientImpl.prototype.enableApiKey = function (keyId) {
    return _super.prototype.enableApiKey.call(this, keyId);
  };

  UserApiKeyAuthProviderClientImpl.prototype.disableApiKey = function (keyId) {
    return _super.prototype.disableApiKey.call(this, keyId);
  };

  return UserApiKeyAuthProviderClientImpl;
}(CoreUserApiKeyAuthProviderClient);

export default UserApiKeyAuthProviderClientImpl;